<style lang="less">
.daMain {
  width: 7.08rem;
  margin: 0.2rem auto 0;
  background: #fff;
  border-radius: 0.04rem;
  color: #000;
  &__goMy {
    text-align: center;
    padding: 0.3rem 0;
    font-size: 0.24rem;
    a,
    a:visited {
      color: #4a90e2;
    }
  }
}
.daCreator {
  @size: 0.3rem;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 0.24rem;
  &__line {
    border-top: 2px dotted #ddd;
    font-size: 1px;
    height: 1px;
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    z-index: 1;
  }
  &::before,
  &::after {
    content: ' ';
    display: block;
    position: absolute;
    top: 50%;
    margin-top: -@size / 2;
    width: @size;
    height: @size;
    border-radius: 50%;
    background: #ca2f13;
    z-index: 2;
  }
  &::before {
    left: -@size / 2;
  }
  &::after {
    right: -@size / 2;
  }
  &__user {
    position: relative;
    top: 0;
    left: 0;
    background: #fff;
    width: 4.05rem;
    margin: 0 auto;
    z-index: 3;
  }
  dl {
    margin: 0;
    padding: 0;
  }
  dd,
  dt {
    margin: 0;
    padding: 0;
    display: inline-block;
    vertical-align: middle;
  }
  dt {
    line-height: 0.64rem;
    padding: 0 0.1rem;
  }
}
.dacLogo {
  position: relative;
  top: 0;
  left: 0;
  width: 0.64rem;
  height: 0.64rem;
  &__me {
    @size: 0.2rem;
    position: absolute;
    top: -0.1rem;
    right: 0;
    width: @size;
    height: @size;
    line-height: @size;
    background: #f00;
    border-radius: 50%;
    font-size: 0.12rem;
    color: #fff;
  }
  .k-user-logo {
    width: 0.64rem;
    height: 0.64rem;
  }
}
</style>
<template>
  <wz-page name="daIndex" :is-loading="isLoading">
    <app-account-bar />
    <k-cdn-img class="mainBanner" src="https://imgcdn-prd.pydp888.com/file/0/1/266583/20201127/562816aa33f90cb929971246b28c83ce.jpg" />
    <div class="daMain">
      <da-gift-card />

      <div class="daCreator">
        <div class="daCreator__line"></div>
        <div class="daCreator__user">
          <dl>
            <dt>发起者</dt>
            <dd>
              <div class="dacLogo">
                <k-user-logo
                  v-if="leader"
                  :src="leader.logoSm"
                  :lv="leader.lvKey"
                  size="small"
                />
                <k-user-logo
                  v-else
                  src="https://imgcdn-prd.pydp888.com/file/0/1/200003/20201028/46d4a35ab225281913d2eb94399e0f80.4_wenhao.png"
                  lv="user"
                  size="small"
                />
                <div v-if="leader && leader.uid === myUid" class="dacLogo__me">
                  我
                </div>
              </div>
            </dd>
          </dl>
        </div>
      </div>

      <da-users v-if="isValidMobile" />
      <div v-else style="height:.2rem;"></div>
      <da-btn-area />
      <app-my-award v-if="isLeader || isInvited" />
    </div>

    <da-rule />
  </wz-page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import DaRule from './comp/da-rule.vue'
import DaUsers from './comp/da-users.vue'
import DaGiftCard from './comp/da-gift-card.vue'
import DaBtnArea from './comp/da-btn-area.vue'

export default {
  components: {
    DaRule,
    DaUsers,
    DaGiftCard,
    DaBtnArea
  },
  data() {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapGetters('account', [
      'myInfo',
      'myUid',
      'myNick',
      'isLogined',
      'isValidMobile'
    ]),
    ...mapGetters('laxin', ['inDCService']),
    ...mapGetters('laxin/da', [
      'leader',
      'isLeader',
      'inviteGroups',
      'isInvited'
    ]),
    query() {
      return this.$route.query || {}
    },
    uid() {
      return +this.query.uid || 0
    }
  },
  methods: {
    ...mapActions('share', ['setShare']),
    ...mapActions('account', ['goLogin', 'goLogout']),
    ...mapActions('laxin/da', ['load', 'bind']),
    async fetch() {
      this.isLoading = false
      await this.load({ uid: this.uid })
      const { isValidMobile, uid, inviteGroups, isLeader, inDCService } = this
      if (isValidMobile) {
        if (!uid) {
          this.$router.replace('/')
        } else if (!inviteGroups.length && !isLeader) {
          await this.$dialog
            .alert({
              message: inDCService
                ? '您是尊贵的典藏版用户，<br>可以免费使用股票池。<br>同时您可以赠送新人福利！'
                : '您是老粉丝用户，不能为好友助力啦!<br>但您可发起助力，有机会获得更多奖励哦！',
              confirmButtonText: inDCService ? '前往赠送' : '前往了解'
            })
            .then(() => this.$router.replace('/'))
        }
      } else {
        if (uid > 0) {
          this.bind() // 打脚印
        } else {
          this.goLogin()
        }
      }
      this.isLoading = false

      this.setShare({
        description:
          '为好友助力，各得15天 520版+高级股票池使用权限！数量有限先到先得！'
      })
    }
  },
  watch: {
    uid: 'fetch'
  },
  mounted() {
    this.fetch()
  }
}
</script>
